
export interface IWallboardNetwork {
  gid: string;
  name: string;
  hexColor: string;
  tasks: IWallboardTask[];
}
export interface IWallboardTask {
  gid: string;
  serviceType: string;
  location: string;
  suburb: string;
  name: string;
  assignee: string;
}


export class WallboardNetwork implements IWallboardNetwork {
  public gid: string = '';
  public name: string = '';
  public hexColor: string = '';
  public tasks: IWallboardTask[] = [];

  constructor(data?: IWallboardNetwork) {
    if (data) {
        for (const property in data) {
            if (data.hasOwnProperty(property)) {
                (this as any)[property] = (data as any)[property];
              }
        }
    }
  }
}

export class WallboardTask implements IWallboardTask {
  public gid: string = '';
  public serviceType: string = '';
  public location: string = '';
  public suburb: string = '';
  public name: string = '';
  public assignee: string = '';

  constructor(data?: IWallboardNetwork) {
    if (data) {
        for (const property in data) {
            if (data.hasOwnProperty(property)) {
                (this as any)[property] = (data as any)[property];
              }
        }
    }
  }
}
